import React from 'react';
import './carousel.css';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import Divider from '@material-ui/core/Divider';
import InfoSection from './infoSection';

let SanMartinMNImg = require('../../src/assets/img/san-martin-mn.jpg')
let UrquizaMNImg = require('../../src/assets/img/urquiza-mn.jpg')
let RocaMNImg = require('../../src/assets/img/julio-roca-mn.jpg')
let RosasMNImg = require('../../src/assets/img/juan-manuel-de-rosas-mn.jpg')
let YrigoyenMNImg = require('../../src/assets/img/hipolito-yrigoyen-mn.jpg')
let PeronMNImg = require('../../src/assets/img/juan-domingo-peron-mn.jpg')
let AlfonsinMNImg = require('../../src/assets/img/alfonsin-menem-mn.jpg')
let CristinaMNImg = require('../../src/assets/img/cristina-kirchner-mn.jpg')

const styles = () => ({
  container: {
    flexGrow: 1,
    marginBottom: '2.5rem',
  },
  titleContainer: {
    textAlign: 'left',
    marginTop: 20,
    padding: '0'
  },
  dividerStyle: {
    backgroundColor: '#9E9E9E',
    opacity: '0.3',
    margin: 20,
  },
})

const EventsLinksOne = (props) => (
  <div className={props.classes.container}>
    <div className={props.classes.titleContainer}>
      <Typography variant='title' color='caption'>
        Etapas más relevantes de nuestra historia:
      </Typography>
      <Divider className={props.classes.dividerStyle}/>
    </div>

    <Grid container /* alignItems="center" justify='center' */ spacing={4}>
        <Grid item xs={12} sm={3}>
          <InfoSection photo={SanMartinMNImg}
                      linkOne={'/sucesos/revolucion-surgimiento-patria-criolla'}
                      linkTwo={'/sucesos/revolucion-surgimiento-patria-criolla-2'}
                      title={'1776-1820: Revolución y el surgimiento de la Patria Criolla.'}/>
        </Grid>
        <Grid item xs={12} sm={3}>
          <InfoSection photo={RosasMNImg}
                    linkOne={'/sucesos/autonomias-organizacion-nacional'}
                    linkTwo={'/sucesos/autonomias-organizacion-nacional-2'}
                    title={'1820-1852: Autonomías Provinciales y Org. Nacional.'}/>
        </Grid>
        <Grid item xs={12} sm={3}>
          <InfoSection photo={UrquizaMNImg}
                    linkOne={'/sucesos/organizacion-nacional'}
                    linkTwo={'/sucesos/organizacion-nacional-2'}
                    title={'1852 - 1880: La Organización Nacional.'}/>
        </Grid>
        <Grid item xs={12} sm={3}>
          <InfoSection photo={RocaMNImg}
                    linkOne={'/sucesos/generacion-del-80'}
                    linkTwo={'/sucesos/generacion-del-80-2'}
                    title={'1880 - 1916: La Generación del 80: El Proyecto Liberal.'}/>
        </Grid>

        <Grid item xs={12} sm={3}>
          <InfoSection photo={YrigoyenMNImg}
                    linkOne={'/sucesos/proyecto-radical'}
                    linkTwo={'/sucesos/proyecto-radical-2'}
                    title={'1916 - 1930: Proyecto Radical: Ampliación del poder político.'}/>
        </Grid>
        <Grid item xs={12} sm={3}>
          <InfoSection photo={PeronMNImg}
                    linkOne={'/sucesos/alternativa-autoritaria'}
                    linkTwo={'/sucesos/alternativa-autoritaria-2'}
                    linkThree={'/sucesos/alternativa-autoritaria-3'}
                    title={'1930 - 1983: Camino en zigzag: alternativa del proyecto autoritario.'}/>
        </Grid>
        <Grid item xs={12} sm={3}>
          <InfoSection photo={AlfonsinMNImg}
                    linkOne={'/sucesos/presidencia-alfonsin'}
                    linkTwo={'#'}
                    titleSection1={'Presidencia de Alfonsín'}
                    titleSection2={'Presidencia de Menem'}
                    title={'1983 - 1999: Una nación en la búsqueda de un proyecto común.'}/>
        </Grid>
        <Grid item xs={12} sm={3}>
          <InfoSection photo={CristinaMNImg}
                    linkOneActual={'#'}
                    linkTwoActual={'#'}
                    linkThreeActual={'#'}
                    titleSection1={'Parte 1: 2000 - 2003'}
                    titleSection2={'Parte 2: 2003 - 2015'}
                    titleSection3={'Parte 3: 2015 - 2020'}
                    title={'2000 - Actualidad: Zigzag neoliberalismo y progresismo.'}/>
        </Grid>
    </Grid>
  </div>
)

export default withStyles(styles)(EventsLinksOne)



// WEBPACK FOOTER //
// ./src/components/eventsLinksOne.js